import { Box, Grid, Paper, Typography } from '@mui/material'
import type { ReactNode } from 'react'

type DetailsRowProps = {
  title: string
  description: string
  children: ReactNode | ReactNode[]
  colsOnDesktop?: number
}

export const DetailsRow = ({ title, description, children, colsOnDesktop = 2 }: DetailsRowProps): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={4}
      sx={({ breakpoints }) => ({ [breakpoints.up('md')]: { flexDirection: 'row' } })}
    >
      <Box sx={({ breakpoints }) => ({ [breakpoints.up('md')]: { flexBasis: 240 } })} flexGrow={0} flexShrink={0}>
        <Typography display="block" variant="body1" fontWeight={600} component="h3">
          {title}
        </Typography>
        <Typography variant="body2" color="gray" component="p">
          {description}
        </Typography>
      </Box>
      <Paper sx={{ p: 2, width: '100%' }}>
        <Grid container spacing={2}>
          {(Array.isArray(children) ? children : [children]).map((child, idx) => (
            <Grid key={`${title}-child-${idx}`} item xs={12} xl={12 / colsOnDesktop}>
              {child}
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  )
}
